// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axiosInstance from "../../services/axiosInstance";

// /* ===============================
//    API CALL – INITIAL LOAD
// ================================ */
// export const fetchAdminLiveTracking = createAsyncThunk(
//   "adminLiveTracking/fetch",
//   async (_, { rejectWithValue }) => {
//     try {
//       const res = await axiosInstance.get("/api/admin/live-tracking");
//       return res.data.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || "API Error");
//     }
//   }
// );

// /* ===============================
//    SLICE
// ================================ */
// const adminLiveTrackingSlice = createSlice({
//   name: "adminLiveTracking",
//   initialState: {
//     employees: [],
//     loading: false,
//     error: null,
//   },

//   reducers: {
//     // 🔹 SOCKET: punch-in
//     addEmployeeLive: (state, action) => {
//       state.employees.push(action.payload);
//     },

//     // 🔹 SOCKET: active / idle / completed
//     updateEmployeeLive: (state, action) => {
//       const index = state.employees.findIndex(
//         (e) => e.employeeId === action.payload.employeeId
//       );

//       if (index !== -1) {
//         state.employees[index] = {
//           ...state.employees[index],
//           ...action.payload,
//         };
//       }
//     },

//     // 🔹 RESET (optional)
//     resetLiveTracking: (state) => {
//       state.employees = [];
//     },
//   },

//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAdminLiveTracking.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchAdminLiveTracking.fulfilled, (state, action) => {
//         state.loading = false;
//         state.employees = action.payload;
//       })
//       .addCase(fetchAdminLiveTracking.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const {
//   addEmployeeLive,
//   updateEmployeeLive,
//   resetLiveTracking,
// } = adminLiveTrackingSlice.actions;

// export default adminLiveTrackingSlice.reducer;




import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

/* ===============================
   API CALL – INITIAL LOAD
================================ */
export const fetchAdminLiveTracking = createAsyncThunk(
  "adminLiveTracking/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/api/admin/live-tracking");
      console.log("✅ [REDUX] Admin live tracking fetched:", res.data.data);
      return res.data.data;
    } catch (err) {
      console.error("❌ [REDUX] Admin fetch error:", err);
      return rejectWithValue(err.response?.data || "API Error");
    }
  }
);

/* ===============================
   SLICE
================================ */
const adminLiveTrackingSlice = createSlice({
  name: "adminLiveTracking",
  initialState: {
    employees: [],
    loading: false,
    error: null,
  },

  reducers: {
    // 🔹 SOCKET: punch-in (NEW EMPLOYEE)
    addEmployeeLive: (state, action) => {
      console.log("🟢 [REDUX] Adding employee:", action.payload);
      
      // Check if employee already exists
      const exists = state.employees.find(
        e => e.employeeId === action.payload.employeeId
      );
      
      if (!exists) {
        state.employees.push({
          ...action.payload,
          totalSeconds: 0, // ✅ Initialize total time
          workHours: 0,
          idleHours: 0,
          totalHours: 0
        });
      }
    },

    // 🔹 SOCKET: active / idle / completed (UPDATE)
    updateEmployeeLive: (state, action) => {
      console.log("🔄 [REDUX] Updating employee:", action.payload);
      
      const index = state.employees.findIndex(
        (e) => e.employeeId === action.payload.employeeId
      );

      if (index !== -1) {
        const current = state.employees[index];
        const update = action.payload;
        
        // ✅ FIXED: Calculate total seconds properly
        const workSeconds = update.workSeconds !== undefined ? update.workSeconds : current.workSeconds;
        const idleSeconds = update.idleSeconds !== undefined ? update.idleSeconds : current.idleSeconds;
        const totalSeconds = workSeconds + idleSeconds;
        
        state.employees[index] = {
          ...current,
          ...update,
          workSeconds,
          idleSeconds,
          totalSeconds, // ✅ CRITICAL: Total time
          workHours: (workSeconds / 3600).toFixed(2),
          idleHours: (idleSeconds / 3600).toFixed(2),
          totalHours: (totalSeconds / 3600).toFixed(2),
        };
        
        console.log(`✅ [REDUX] Updated employee ${current.name}: ${totalSeconds}s total`);
      } else {
        console.warn("⚠️ [REDUX] Employee not found for update:", action.payload.employeeId);
      }
    },

    // 🔹 RESET (optional)
    resetLiveTracking: (state) => {
      console.log("🔄 [REDUX] Resetting live tracking");
      state.employees = [];
      state.loading = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminLiveTracking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminLiveTracking.fulfilled, (state, action) => {
        state.loading = false;
        state.employees = action.payload.map(emp => ({
          ...emp,
          // ✅ Ensure totalSeconds is calculated
          totalSeconds: (emp.workSeconds || 0) + (emp.idleSeconds || 0),
          workHours: emp.workHours || ((emp.workSeconds || 0) / 3600).toFixed(2),
          idleHours: emp.idleHours || ((emp.idleSeconds || 0) / 3600).toFixed(2),
          totalHours: emp.totalHours || (((emp.workSeconds || 0) + (emp.idleSeconds || 0)) / 3600).toFixed(2),
        }));
        console.log("✅ [REDUX] Employees loaded:", state.employees.length);
      })
      .addCase(fetchAdminLiveTracking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        console.error("❌ [REDUX] Failed to load employees:", action.payload);
      });
  },
});

export const {
  addEmployeeLive,
  updateEmployeeLive,
  resetLiveTracking,
} = adminLiveTrackingSlice.actions;

export default adminLiveTrackingSlice.reducer;